import styles from './FJVoiceItem.module.less';
import FJAvatarAudioPlay from '../../../../common/components/audio/FJAvatarAudioPlay/FJAvatarAudioPlay.jsx';
import FJFavoriteIcon from '../../../../assets/svg/ttv/library-favorite.svg?react';
import FJDefaultFavoriteIcon from '../../../../assets/svg/ttv/library-Favorite-light.svg?react';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';

const FJVoiceItem = props => {
    const {
        audioUrl,
        imgUrl,
        description,
        name,
        value,
        language,
        isFavorite,
        onFavorite,
        hasFavorite,
        onUse,
        isFavoriteLoading,
    } = props;

    const _playRef = useRef(null);

    const _changePlay = () => {
        _playRef.current.changePlay();
    };

    return (
        <div className={styles.box} id={value} onClick={_changePlay}>
            <div className={styles.left}>
                <FJAvatarAudioPlay
                    audioUrl={audioUrl}
                    imgUrl={imgUrl}
                    playClassname={styles.play_area}
                    ref={_playRef}
                />
                <div className={styles.info}>
                    <FJTextWithEllipsis className={styles.name} text={name} />
                    <FJTextWithEllipsis className={styles.desc} text={description} />
                </div>
            </div>
            <div className={styles.language}>{language}</div>
            <div className={styles.right}>
                <FJButton className={styles.use_btn} type='gradient' text='use' onClick={onUse} />
                {hasFavorite && (
                    <FJButton
                        icon={isFavorite ? <FJFavoriteIcon /> : <FJDefaultFavoriteIcon />}
                        className={classNames(styles.icon_btn, isFavorite ? styles.is_favorite : styles.no_favorite)}
                        type='white'
                        onClick={onFavorite}
                        isLoading={isFavoriteLoading}
                        loadingStyle={{ width: '14px', height: '14px' }}
                    />
                )}
            </div>
        </div>
    );
};
FJVoiceItem.propTypes = {
    audioUrl: PropTypes.string,
    imgUrl: PropTypes.string,
    description: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    language: PropTypes.string,
    isFavorite: PropTypes.bool,
    onFavorite: PropTypes.func,
    hasFavorite: PropTypes.bool,
    onUse: PropTypes.func,
    isFavoriteLoading: PropTypes.bool,
};
export default FJVoiceItem;
